import React, { useMemo } from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing';
import StackhawkMappingForm from './StackhawkMappingForm';
import StackhawkCredentialsForm from './StackhawkCredentialsForm';
import { DELIMITER } from './StackhawkMappingForm';
import _ from 'lodash';
import { CellRenderers } from 'utils/tableUtils';
import ContentOverlay from 'components/ContentOverlay';



export default function StackhawkConfigListing(props){
    const columns = useMemo(() => [{
        title: "Application - [Environments]",
        dataIndex: "appName",
        width: 240,
        render: (appName, record) => {
            if(_.isEmpty(appName)) {
                return CellRenderers.VALUE_OR_NA(appName)
            }
           
            const projectNames = _.split(appName, ',');
            const projectObj = {}
               
            _.forEach(projectNames, project => {
                const index = project.lastIndexOf(DELIMITER)
                const _project = project.substring(0, index === -1 ? undefined : index);
                if(index !== -1){
                  const references = project.substring(index + 1, project.length);
                  projectObj[_project] = _.split(references.replace(/;/g, ', '), ',')
                }else if(record?.project_version){
                    projectObj[_project] = _.split(record?.project_version, ',')
                }else{
                    projectObj[_project] = undefined
                }
                
            })

            const renderName = Object.keys(projectObj).map(item => projectObj[item] ? `${item} - [${projectObj[item]}]` : item )


            const content = renderName.map(item => <p>{item}</p>)

            return <ContentOverlay content={content} minHeight={40}/>
        } 
    }], [])

    return (
        <GenericPullConfigListing 
            {...props}
            toolName={props.name}
            extraColumns={columns}
            MappingForm={StackhawkMappingForm}
            CredentialsForm={StackhawkCredentialsForm}
        />
    )
}